<template>
	<div class="screen-wrapper1">
		<div
			class="screen" id="screen"
			:style="{'width': `${sWidth}px`, 'height': `${sHeight}px`, 'background': backGround}">
			<div class="demo-root">
				<span
					v-for="(text, i) in textList"
					:key="'textList' + i"
					:style="{'fontSize': `${fontSize}px`, 'color': color, 'fontFamily': fontFamily}">
					{{ text }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import { dataInterface } from '@/api/dataInterfaceApi'
export default{
	components: {},
	data() {
		const { sWidth, sHeight, text, textList, type, id, ff, fs, bg, c } = this.$route.query
		return {
			sWidth: sWidth || 2560,
			sHeight: sHeight || 80,
			textList: textList ? textList.split(',') : (text ? [text] : []),
			type,
			id: id || 'all',
			fontFamily: ff || '华为楷体',
			fontSize: fs || 72,
			backGround: bg || '#fff',
			color: c || '#12aee1'
		}
	},
	beforeCreate() {},
	mounted(){
		console.log(this.sWidth, 'sdfsdf')
		//初始化自适应  ----在刚显示的时候就开始适配一次
		this.handleScreenAuto()
		//绑定自适应函数   ---防止浏览器栏变化后不再适配
		window.onresize = (function(){
			this.handleScreenAuto()
		})

		if(this.type == 1) {
			// 储能放电量（kwh）/累计放电量（kwh）/额定容量（MWH）
			this.getFangdianliang()
		}
		else if(this.type == 2) {
			// 光伏当日发电量 光伏累计发电量、光伏额定装机容量
			this.getFadianliang()
		}
		else if(this.type == 3) {
			// 充电桩充电量、液冷超充今日充电量
			this.getChongdianliang()
		}
	},
	deleted(){
		window.onresize = null
	},
	methods: {
		//数据大屏自适应函数
		handleScreenAuto(){
			const designDraftWidth = this.sWidth //设计稿的宽度
			const designDraftHeight = this.sHeight //设计稿的高度
			//根据屏幕的变化适配的比例
			const scale = document.documentElement.clientWidth / document.documentElement.clientHeight < designDraftWidth / designDraftHeight ?
				(document.documentElement.clientWidth / designDraftWidth) :
				(document.documentElement.clientHeight / designDraftHeight)

			console.log('//缩放比例', scale)
			// document.querySelector('#screen').style.transform = `scale(${scale}) translate(-50%)`;
			let scaleY = parseFloat(localStorage.getItem('bigScreen::scaleY')) || 1
			if(sessionStorage.getItem('fromUser') == 'guizhou') {
				document.querySelector('#screen').style.transform = `scale(${scale}, ${scale * 1.6}) translate(-50%)`;
			} else {
				document.querySelector('#screen').style.transform = `scale(${scale}, ${scale * scaleY}) translate(-50%)`;
			}
		},
		// 储能放电量（kwh）/累计放电量（kwh）/额定容量（MWH）
		async getFangdianliang() {
			let params = {
				'enCode': 'nengyuanzhongxin-cn-fangdianliang', // 接口请求code
				'@station_id': this.id // 接口传入参数 储能站ID
			}
			let res = await dataInterface.dataFaceApi(params)
			console.log('储能放电量/累计放电量/额定容量', res)
			if(!res || !res.length) return
			let data = res[0] || {}
			this.textList = [`储能电站装机容量${data.rated_capacity}MWh`, `今日放电量${data.day_elect}kWh`, `累计放电量${data.acc_elect}kWh`]
			console.log('this.textList', this.textList)
		},
		// 光伏当日发电量 光伏累计发电量、光伏额定装机容量
		async getFadianliang() {
			// 光伏额定装机容量
			let params = {
				'enCode': 'nengyuanzhongxin-gf-zhuangjirongliang',// 接口请求code
				'@station_id': this.id // 接口传入参数 光伏站ID
			}
			let res = await dataInterface.dataFaceApi(params)
			console.log('光伏额定装机容量', res)
			if(res && res[0]) {
				this.textList.push(`光伏系统装机容量${res[0].rated_capacity}kW`)
			}
			// 光伏当日发电量
			let params1 = {
				'enCode': 'nengyuanzhongxin-gf-jinrifadianliang',
				'@station_id': this.id
			}
			let res1 = await dataInterface.dataFaceApi(params1)
			console.log('光伏当日发电量', res1)
			if(res1 && res1[0]) {
				this.textList.push(`今日发电量${res1[0].electric}kWh`)
			}
			// 光伏累计发电量
			let params2 = {
				'enCode': 'nengyuanzhongxin-gf-leijifadianliang',
				'@station_id': this.id
			}
			let res2 = await dataInterface.dataFaceApi(params2)
			console.log('光伏累计发电量', res2)
			if(res2 && res2[0]) {
				this.textList.push(`累计发电量${res2[0].total_electric}kWh`)
			}
		},
		// 充电桩充电量、液冷超充今日充电量
		async getChongdianliang() {
			let params = {
				'enCode': 'nengyuanzhongxin-cdz-chongdianliang',
				'@station_id': this.id // 接口传入参数 光伏站ID
			}
			let res = await dataInterface.dataFaceApi(params)
			console.log('储能放电量/累计放电量/额定容量', res)
			if(!res || !res.length) return
			this.textList = [`充电桩今日充电量${res[0].cddl}kWh`, `液冷超充今日充电量${res[0].ccdl}kWh`]
		},
	},
	destroyed() {
		clearInterval(this.pageInterval)
	}
}
</script>

<style lang="scss" scope>
@import '@/assets/scss/pc.scss';
@import '@/assets/scss/main-map.scss';

.screen-wrapper1 {
	height: 100%;
	width: 100%;
	font-size: 16px;
	color: #fff;
	background: #fff;
	color: #000;
	font-weight: bold;
	.screen {
		overflow: hidden;
		display: inline-block;
		transform-origin: 0 0;
		position: absolute;
		left: 50%;
		.demo-root{
			width: 100%;
			height: 100%;
			// font-size: 60px;
			display: flex;
			align-content: center;
			justify-content: space-around;
			> span {
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
	}
}
</style>